module.exports = __webpack_public_path__ + "img/yishi1.4e69db00.jpg";